module.exports = __webpack_public_path__ + "img/person1.01faabc0.png";